import { Suspense } from "react";
import HeaderWebsite from "../../components/HeaderWebsite";
import ConfigPage from "../../components/ConfigPage";

export default function ConfigPageWrapper(props) {
  const {
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
    notificationVolume,
    setNotificationVolume,
    userData,
    ...configProps
  } = props;

  return (
    <>
      <HeaderWebsite
        statusMode={statusMode}
        setStatusMode={setStatusMode}
        isLoggedIn={isLoggedIn}
        showLogoutButton={showLogoutButton}
        notificationVolume={notificationVolume}
        setNotificationVolume={setNotificationVolume}
        userData={userData}
        user={userData}
      />
      <Suspense fallback={<div>Loading...</div>}>
        <ConfigPage
          statusMode={statusMode}
          setStatusMode={setStatusMode}
          isLoggedIn={isLoggedIn}
          showLogoutButton={showLogoutButton}
          notificationVolume={notificationVolume}
          setNotificationVolume={setNotificationVolume}
          userData={userData}
          user={userData}
          {...configProps}
        />
      </Suspense>
    </>
  );
}
